import React from 'react';

/** Stock actual no site (Saleor/Typesense, sincronizado antes de cada ranking). */
const StockBadge: React.FC<{ inStock?: boolean | null; className?: string }> = ({ inStock, className = '' }) => {
  if (inStock === undefined || inStock === null) return <span className={`text-muted ${className}`}>-</span>;
  return inStock ? (
    <span className={`badge bg-success ${className}`} title="Com stock no site agora">Com stock</span>
  ) : (
    <span className={`badge bg-secondary ${className}`} title="Sem stock no site agora">Sem stock</span>
  );
};

/** Resumo "N com stock · M sem stock" para o cabeçalho das listagens. */
export const stockSummary = (flags: (boolean | undefined)[]): string => {
  const withStock = flags.filter((f) => f === true).length;
  const without = flags.filter((f) => f === false).length;
  return `${withStock} com stock · ${without} sem stock`;
};

export default StockBadge;
